import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ts-spinner-svg',
  templateUrl: './ts-spinner-svg.component.html',
  styleUrls: ['./ts-spinner-svg.component.scss']
})
export class TsSpinnerSVGComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
